import { withSagas } from 'metrix-common3';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import getStorefrontConfiguration from '../../actions/storefront/getStorefrontConfiguration';
import reduceStorefrontConfiguration from '../../actions/storefront/reduceStorefrontConfiguration';
import storefrontSaga from '../../sagas/storefront/saga';
import { selectStorefrontConfiguration } from '../../selectors/storefront/selectStorefrontConfiguration';
import { selectUserInterface } from '../../selectors/storefront/selectUserInterface';

class StoreFrontProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false,
            error: null,
        };
    }

    componentDidMount() {
        this.initializeStorefront();
    }

    initializeStorefront() {
        const { context, storefront } = this.props;

        if (context?.offline) {
            this.props.doReduceStorefrontConfiguration({});
            this.setState({ initialized: true });
        } else if (!storefront) {
            this.props.doGetStorefrontConfiguration();
        }
    }

    componentDidUpdate(prevProps) {
        // Initialize if we get context after mount
        if (!this.state.initialized && !prevProps.context && this.props.context) {
            this.initializeStorefront();
        }

        // Mark as initialized when we get storefront config
        if (!this.state.initialized && !prevProps.storefront && this.props.storefront) {
            this.setState({ initialized: true });
        }
    }

    render() {
        try {
            const { context, storefront, children } = this.props;

            // Early return if no children
            if (!children) {
                console.warn('[StorefrontProvider] No children provided');
                return null;
            }

            // Don't render anything until we're initialized in offline mode
            // or we have storefront config in online mode
            if (!this.state.initialized && !context?.offline && !storefront) {
                return null;
            }

            const enrichedContext = {
                ...context,
                storefront: storefront || {},
                userInterface: this.props.userInterface || {},
            };

            // Handle array of children
            if (Array.isArray(children)) {
                console.warn('[StorefrontProvider] Multiple children provided, using first child');
                if (children.length === 0) return null;
                const firstChild = children[0];
                if (!React.isValidElement(firstChild)) {
                    console.error('[StorefrontProvider] First child is not a valid React element');
                    return null;
                }
                return React.cloneElement(firstChild, { context: enrichedContext });
            }

            // Handle single child
            if (!React.isValidElement(children)) {
                console.error('[StorefrontProvider] Children is not a valid React element:', children);
                return null;
            }

            return React.cloneElement(children, { context: enrichedContext });
        } catch (error) {
            console.error('[StorefrontProvider] Error in render:', error);
            this.setState({ error });
            return <div>Error in StorefrontProvider: {error.message}</div>;
        }
    }
}

const mapStateToProps = createStructuredSelector({
    storefront: selectStorefrontConfiguration(),
    userInterface: selectUserInterface(),
});

const mapDispatchToProps = (dispatch) => ({
    doGetStorefrontConfiguration: () => dispatch(getStorefrontConfiguration()),
    doReduceStorefrontConfiguration: (payload) => dispatch(reduceStorefrontConfiguration(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withSagas({ key: 'storefront', saga: storefrontSaga });

export default compose(withConnect, withSaga)(StoreFrontProvider);
